export const BECOMEAMEMBER_SUMMARY = "BECOMEAMEMBER_SUMMARY";
export const CALCULATION_PRICE = "CALCULATION_PRICE";
export const CLEARCALCULATION_PRICE = "CLEARCALCULATION_PRICE";
export const SHOW_CHANGE_MEMBERSHIP_MODELS = "SHOW_CHANGE_MEMBERSHIP_MODELS";
export const COMPARISONTOOL_APIBODY = "COMPARISONTOOL_APIBODY";
export const CLEARCOMPARISONTOOL_APIBODY = "CLEARCOMPARISONTOOL_APIBODY";

export function becomeAMemberSummary(val) {
  return {
    type: BECOMEAMEMBER_SUMMARY,
    membership: val.membership,
    membershipCode: val.membershipCode,
    country: val.country,
    engine: val.engine,
    color: val.color,
    financing: val.financing,
    deposit: val.deposit,
    price: val.price,
    formattedPrice: val.formattedPrice,
    formattedMsrp: val.formattedMsrp,
    currency: val.currency,
    shopspuId: val.shopspuId,
    customerNumber: val.customerNumber
  };
}
export function calculationPrice(val) {
  return {
    type: CALCULATION_PRICE,
    ...val
  };
}
export function clearCalculationPrice(val) {
  return {
    type: CLEARCALCULATION_PRICE
  };
}
export function comparisonToolApiBody(val) {
  return {
    type: COMPARISONTOOL_APIBODY,
    body: val
  };
}
export function clearComparisonToolApiBody(val) {
  return {
    type: CLEARCOMPARISONTOOL_APIBODY
  };
}
export function setShowChangeMembershipModels(val) {
  return {
    type: SHOW_CHANGE_MEMBERSHIP_MODELS,
    level1: val.level1,
    level2: val.level2,
    level3: val.level3,
    levelSame: val.levelSame,
    fromLevel3: val.fromLevel3,
    url: val.url
  };
}
